import { render, staticRenderFns } from "./BannerPunish.vue?vue&type=template&id=e8f31e12&"
import script from "./BannerPunish.vue?vue&type=script&lang=js&"
export * from "./BannerPunish.vue?vue&type=script&lang=js&"
import style0 from "./BannerPunish.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/workspace/yx-web-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e8f31e12')) {
      api.createRecord('e8f31e12', component.options)
    } else {
      api.reload('e8f31e12', component.options)
    }
    module.hot.accept("./BannerPunish.vue?vue&type=template&id=e8f31e12&", function () {
      api.rerender('e8f31e12', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Activity/Children/GuideChildren/KpidataChildren/BannerPunish.vue"
export default component.exports